import { useMediaQuery } from 'react-responsive';

export const useResponsive = () => {
    const isMobile = useMediaQuery({ query: '(max-width: 767px)' }); // 768px is min-width for md
    const isTabletOrSmaller = useMediaQuery({ query: '(max-width: 1023px)' }); // 1024px is min-width for lg

    return { isMobile, isTabletOrSmaller };
};
